import { initA11y } from './modules/a11y';
import { initHeader } from './modules/header';

document.addEventListener('DOMContentLoaded', () => {
  initA11y();
  initHeader();
});


